<template>
    <div>
        <slot :handler="handleVerifyResultsClicked"></slot>

        <verify-results-dialog
            v-model="enteringPasswordToVerifyResults"
            :meet-id="meet.id"
            persistent
            @verified="handleVerificationSuccess"
        />
    </div>
</template>

<script>
import Meet from '@/Models/Meet.js';
import VerifyResultsDialog from '@/Components/VerifyResultsDialog.vue';

export default {
    name: 'VerifyResultsControl',

    components: { VerifyResultsDialog },

    props: {
        meet: {
            type: Meet,
            required: true,
        },
    },

    data: () => ({
        enteringPasswordToVerifyResults: false,
    }),

    methods: {
        handleVerifyResultsClicked() {
            const { verifiableMeetIds } = this.$store.state;

            if (verifiableMeetIds === '*' || verifiableMeetIds.includes(this.meet.id)) {
                this.handleVerificationSuccess();
            } else {
                this.enteringPasswordToVerifyResults = true;
            }
        },

        handleVerificationSuccess() {
            Meet.commit(state => {
                state.verifyingResults = this.meet.id;
            });
        },
    },
};
</script>
